export default "__VITE_ASSET__d8bb715c__"